import {Component, OnInit} from '@angular/core';
import {slideToLeft} from "../../../../animations/router.animations";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PopupComponent} from "../../../../shared/popup/popup.component";
import {LoaderService} from "../../../../service/loader.service";
import {PrizesService} from "../../../../service/prizes/prizes.service";
import {Router} from "@angular/router";
import {PROJECT_MESSAGES} from "../../../../config/project";
import {RouterPaths} from "../../../../config/testing/router.paths.model";
import {StylingService} from "../../../../service/styling.service";

@Component({
    selector: 'app-new-address',
    templateUrl: './new-address.component.html',
    styleUrls: ['./new-address.component.scss'],
    animations: [slideToLeft],
    host: {'[@slideToLeft]': ''}
})
export class NewAddressComponent implements OnInit {
    newAddressForm: FormGroup;
    constructor(private formBuilder: FormBuilder,
                private prizesService: PrizesService,
                private loaderService: LoaderService,
                private router: Router,
                private stylingService: StylingService,
                private popupComponent: PopupComponent,) {

    }

    ngOnInit() {
        this.newAddressForm = this.formBuilder.group({
            address: ['', Validators.required],
            save: [true]
        });
    }

    onSubmit() {
        const address = this.getInput('address');
        const save = this.getInput('save');
        const saveText = save ? ' and save it for future use' : '';

        if (address) {
            this.popupComponent.showPopupAgreement({text: `Add address ${address} to available addresses${saveText}?`}, (status) => {
                if (status) {
                    this.submit();
                }
            });
        } else {
            this.popupComponent.showPopupError({text: PROJECT_MESSAGES.notAllFieldsAreFilled});
        }
    }

    submit() {
        const address = this.getInput('address');
        const save = this.getInput('save');

        if (!address) {
            this.popupComponent.showPopupError({text: PROJECT_MESSAGES.notAllFieldsAreFilled});
            return;
        }

        if (save !== 'false' && save !== false) {
            this.prizesService.checkAddAddress(address).subscribe(data => {
                this.submitResult(data);
            }, (error) => {
                this.loaderService.hideAndShowTryAgain()
            }, () => {
                this.loaderService.hide();
            });
        } else {
            this.prizesService.setTemporaryAddress(address);
            this.goBack();
        }

    }

    getInput(field) {
        if (this.newAddressForm.controls[field]) {
            return this.newAddressForm.controls[field].value;
        }
    }

    submitResult(data) {
        if(data.status === true){
            this.popupComponent.showPopupSuccess({text:data.message});
            this.goBack();
        } else if(data.status === false) {
            this.popupComponent.showPopupError({text:data.message});
        } else {
            this.loaderService.hideAndShowTryAgain();
        }
    }

    goBack() {
        this.newAddressForm.controls.address.setValue('');
        this.newAddressForm.controls.save.setValue(true);

        this.router.navigate([RouterPaths.prizes.mailCheck]);
    }

    onSaveAddress(e) {
        const checked = e.target.checked;
        this.newAddressForm.controls.save.setValue(!!checked);
    }

    onInput($event) {
        this.newAddressForm.get('address').patchValue( $event.target.value.trim(), {emitEvent: false} );
    }

    getActiveColor() {
        return this.stylingService.getPageColor();
    }
}
